/* eslint-disable react/no-array-index-key */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Editor } from 'primereact/editor';
import { TabMenu } from 'primereact/tabmenu';
import { Panel } from 'primereact/panel';
import { Ripple } from 'primereact/ripple';
import { Divider } from 'primereact/divider';
import { SplitButton } from 'primereact/splitbutton';

import ModalPreview from '@components/Section/ModalPreview'

import { SET_VALUES_SECTION } from '@constants/actionType';


import store from '@store';

class outServiceForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTabIndex: 0,
      loadingPage: true,
      languagePreview: [],
      showModalPreview: {
        title: '',
        visible: false,
        children: ''
      }
    }
    this.initialValuesForm = {
        title: '',
        cards: [],
    }
    this.initialValuesCardForm = {
      title: '',
      link: '',
      description: '',
    };
  }

  componentDidMount() {
    const { keysLenguages, _outService, itemsTabsLenguages, t } = this.props;
    if (_outService) {
      this.setState({
        ..._outService,
      });
    } else {
      keysLenguages.map((item) =>
        this.setState({
          [item]: {
            ...this.initialValuesForm,
            cards: [{ ...this.initialValuesCardForm }],
          },
        })
      );
    }
    const languagePreview = itemsTabsLenguages.map((item) => {
      let label = t('En') + ' ' + item.label.replace(`(${t('Obligatorio')})`, '')
      return {
        label,
        icon: 'pi pi-eye',
        command: () => {
          this.onPreview(`${item.key}`)
        }
      }
    })
    this.setState({ languagePreview })
    this.setState({ loadingPage: false });
  }

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }));
  };

  onChange = ({ target }) => {
    const [language, name] = target.name.split('-');
    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: target.value },
    }));
  };

  onChangeCard = ({target}) => {
    const [language, index, name] = target.name.split('-');
    const newCard = this.state[language].cards
    newCard[index][name] = target.value
    this.setState((prevState) => ({
      [language]: { ...prevState[language], cards: newCard },
    }));
  };

  onChangeEditor = (names, e) => {
    const [language, name] = names.split('-');

    this.setState((prevState) => ({
      [language]: { ...prevState[language], [name]: e.textValue },
    }));
  } 

  onSubmit = async (e) => {
    e.preventDefault();
    const { success } = this.props
    await this.setValuesToStateGlobal()
    success();
  };

  setValuesToStateGlobal = async () =>  {
    const { keysLenguages } = this.props;
    const getValues = keysLenguages.reduce((accum, item) => {
      accum[item] = this.state[item];
      return accum;
    }, {});

    return await store.dispatch({
      type: SET_VALUES_SECTION,
      payload: { outService: getValues },
    });
  }

  onPreview = async (language) => {
    // const { keysLenguages } = this.props
    // const { activeTabIndex } = this.state;
    await this.setValuesToStateGlobal()
    // const language = keysLenguages[activeTabIndex];

    return this.setState({showModalPreview: {
      visible: true,
      language,
    }})
  }

  onHideModalPreview = () => {
    this.setState({showModalPreview: { visible: false }})
  }

  template = (options, index) => {
    const { keysLenguages } = this.props;
    const getCards = this.state[keysLenguages[0]].cards;
    const toggleIcon = options.collapsed
      ? 'pi pi-chevron-down'
      : 'pi pi-chevron-up';
    const className = `${options.className} p-jc-beetween`;
    const titleClassName = `${options.titleClassName} p-pl-1`;

    return (
      <div className={className}>
        <div>
          <button
            type="button"
            className={options.togglerClassName}
            onClick={options.onTogglerClick}
          >
            <span className={toggleIcon} />
            <Ripple />
          </button>
          <span className={titleClassName}>
            Servicio {index + 1} de {getCards.length}
          </span>
        </div>
        { getCards.length !== 1 && (
          <div>
            <Button
              icon="pi pi-trash"
              type="button"
              className="p-button-text p-button-plain"
              onClick={() => this.removeService(index)}
            />
          </div>
        )}
      </div>
    );
  };

  addService = () => {
    const { keysLenguages } = this.props;
    return keysLenguages.map((key) => {
      const newCard = this.state[key].cards;
      newCard.push({ ...this.initialValuesCardForm });
      this.setState((prevState) => ({
        [key]: { ...prevState[key], cards: newCard },
      }));
    });
  };

  removeService = (index) => {
    const { keysLenguages } = this.props;
    return keysLenguages.map(key => {
      const newCard = this.state[key].cards
      newCard.splice(index, 1)
      this.setState((prevState) => ({
        [key]: { ...prevState[key], cards: newCard },
      }));
    })
  };

  render() {
    const {
      t,
      btnSubmitLoading,
      history,
      itemsTabsLenguages,
      keysLenguages,
      onBack,
    } = this.props;
    const { activeTabIndex, loadingPage, showModalPreview, languagePreview  } = this.state;

    const renderByTabLenguage = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      return (
        <>
          <div className="p-col-12 p-field">
            <label htmlFor="title" className="p-text-bold">
              Titulo
            </label>
            <InputText
              name={`${prefixLenguage}-title`}
              type="text"
              value={this.state[prefixLenguage].title}
              onChange={this.onChange}
              autoFocus
              // className={classNames({
              //   'p-invalid': isFormFieldValid('title'),
              // })}
            />
          </div>
        </>
      );
    };

    const renderCards = () => {
      const prefixLenguage = keysLenguages[activeTabIndex];
      const getCards = this.state[keysLenguages[0]].cards;
      return getCards.map((item, index) => (
        <div className="p-col-12" key={`card-${index}`}>
          <Panel
            headerTemplate={(e) => this.template(e, index)}
            collapsed={index >= 1}
            toggleable
          >
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                />
              )}
            </div>
            <div className="p-col-12 p-field">
              <label htmlFor="title" className="p-text-bold">
                Titulo
              </label>
              <InputText
                name={`${prefixLenguage}-${index}-title`}
                type="text"
                value={this.state[prefixLenguage].cards[index].title}
                onChange={this.onChangeCard}
                autoFocus
                // className={classNames({
                //   'p-invalid': isFormFieldValid('title'),
                // })}
              />
            </div>
            <div className="p-col-12 p-field">
              <label htmlFor="title" className="p-text-bold">
                Link
              </label>
              <InputText
                name={`${prefixLenguage}-${index}-link`}
                type="text"
                value={this.state[prefixLenguage].cards[index].link}
                onChange={this.onChangeCard}
                autoFocus
                // className={classNames({
                //   'p-invalid': isFormFieldValid('title'),
                // })}
              />
            </div>
            <div className="p-col-12 p-field">
              <label htmlFor="description" className="p-text-bold">
                Descripcion
              </label>
              <Editor
                name={`${prefixLenguage}-${index}-description`}
                style={{ height: '200px' }}
                value={this.state[prefixLenguage].cards[index].description}
                onTextChange={e => this.onChangeCard({target: { name: `${prefixLenguage}-${index}-description`, value: e.textValue }})}
                // className={classNames({
                //   'p-invalid': isFormFieldValid('description'),
                // })}
              />
            </div>
          </Panel>
        </div>
      ));
    };

    if (loadingPage) return true;
    return (
      <>
        <form onSubmit={this.onSubmit} autoComplete="false">
          <div className="p-fluid p-grid p-mb-4">
            <div className="p-col-12 p-text-right p-d-flex p-jc-end">
              {/* <Button
                label={t('Previsualizar')}
                icon="pi pi-eye"
                className="p-button-raised  p-button-info p-button-text"
                style={{width: '130px'}}
                onClick={() => this.onPreview()}
                type="button"
              /> */}
              <SplitButton
                label={t('Vista Previa')}
                icon="pi pi-eye"
                onClick={() => this.onPreview(keysLenguages[0])}
                className="p-button-info"
                style={{ width: '150px' }}
                model={languagePreview}
              />
            </div>
            <div className="p-col-12">
              {itemsTabsLenguages && (
                <TabMenu
                  model={itemsTabsLenguages}
                  activeIndex={activeTabIndex}
                  onTabChange={(e) => this.setState({ activeTabIndex: e.index })}
                />
              )}
            </div>
            {renderByTabLenguage()}
            <Divider type="dashed" />
            <div className="p-col-12 p-text-right">
              <Button
                label="Agregar servicio"
                type="button"
                className="p-button-info"
                onClick={() => this.addService()}
                style={{width: '150px'}}
              />
            </div>
            {renderCards()}
          </div>
          <div className="p-col-12 footer-btn">
            <div className="p-d-flex p-jc-between">
              <Button
                label={t('Regresar')}
                type="button"
                className="p-button-secondary"
                onClick={() => onBack()}
              />
              <Button
                label={t('Continuar')}
                type="submit"
                className="p-button-primary"
                loading={btnSubmitLoading}
              />
            </div>
          </div>
        </form>
        <div>
          { showModalPreview.visible && (
            <ModalPreview
              language={showModalPreview.language}
              onHide={this.onHideModalPreview}
            />
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  _outService: state.section.outService,
  keysLenguages: state.catalogs.keysLanguageCatalog,
  itemsTabsLenguages: state.catalogs.tabsLanguageCatalog,
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, null)
)(outServiceForm);
